import { useEffect, useRef, useState } from "react"
import { useLoaderData, useLocation, useNavigate } from "react-router-dom"
import { useAuth } from "contexts/auth-context"
import { setIsAdmin, setIsSupervisor, setIsOwner } from "helpers/general-helper"
import { lang } from "config"
import moment from 'moment';
const idLocale = require('moment/locale/id'); 
moment.locale('id', idLocale);

const Dashboard = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { can, user, isSuper, currentBranch } = useAuth()
    const prevData = useRef({})
    const data = useLoaderData() || prevData.current
    const [transition, setTransition] = useState(location.state?.transition)
    const [thisMonth, setThisMonth] = useState(moment(new Date()).format('MMMM, YYYY'))

    useEffect(() => {
        if (location.state?.cache === 'clear') {
            window.history.replaceState({}, document.title)
            navigate(0)
        }

        if (can('purchase.create')) {
            setIsAdmin(1)
        } else {
            setIsAdmin(0)
        }
        if (can('purchase.approve')) {
            setIsSupervisor(1)
        } else {
            setIsSupervisor(0)
        }
        if (can('purchase.send')) {
            setIsOwner(1)
        } else {
            setIsOwner(0)
        }

    }, [])

    useEffect(() => {
        if (data) {
            prevData.current = data
        }
    }, [data])

    return (
        <div className="space-y-8">
            <div className="space-y-2">
                <span className="text-sm font-medium">{`${lang.statistic} ${thisMonth}`}</span>
                <div className="flex space-x-8 overflow-x-auto rounded-xl">
                    {data?.data?.length !== 0 && data?.data?.map((row, index) => (
                        <div className="flex flex-col justify-between flex-shrink-0 w-56 h-56 overflow-hidden text-xs topography rounded-xl bg-neutral-200">
                            <div className="p-4 font-medium">{row.name}</div>
                            <div className="p-4 bg-neutral-800 bg-opacity-10">
                                <div>Total data</div>
                                <div className="text-2xl font-medium">{row.total}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Dashboard